import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import { Provider } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import App from "./App";
import store from './store';
import { ThemeProvider } from './context/ThemeContext';


import "bootstrap/dist/css/bootstrap.min.css";
import "assets/css/light-bootstrap-dashboard-pro-react.css";
import "assets/css/demo.css";
import 'assets/css/theme.css';
import 'assets/css/style.css';

import 'assets/css/comprehensive-theme-fixes.css';

import 'react-toastify/dist/ReactToastify.css';
import 'sweetalert2/dist/sweetalert2.min.css';

toast.configure({
  position: toast.POSITION.TOP_RIGHT,
  pauseOnHover: true,
  newestOnTop: true,
  autoClose: 3000
});

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider>
      <ToastContainer newestOnTop={true}/>
      <BrowserRouter basename={'/'}>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </Provider>,
  document.getElementById("root")
);